import React from 'react';
import { motion } from 'framer-motion';
export function Header() {
  return <motion.header initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className="w-full py-8 px-6 md:px-12 flex justify-center items-center border-b border-gold/20 bg-cream/80 backdrop-blur-sm sticky top-0 z-50" data-id="element-49">
      <div className="text-2xl font-serif tracking-widest text-charcoal uppercase font-semibold" data-id="element-50">
        Belleza<span className="text-gold font-light italic ml-1" data-id="element-51">Latina</span>
      </div>
    </motion.header>;
}